import React, { useEffect, useState } from 'react';
import { Drawer, DatePicker, Button, Radio } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import moment from "moment";
import '../userProfileAttendanceDetailsV3.css';
const calendarIcon = require('../../userManagementV2/dashboardV3/calendar.svg').default;

const ReportDrawer = ({ drawerVisible, setDrawerVisible, endDateContainer, startDateContainer, selectedRangeContainer, storeStartDate, storeEndDate, storeSelectedRange, usersDownloadReport }) => {

    const [value, setValue] = useState(0);
    const [isDownloadBtnLoading, setIsDownloadBtnLoading] = useState(false);

    const handleCancel = (e) => {
        e?.stopPropagation?.();
        setDrawerVisible(false);
    };

    const onRadioChange = (e) => {
        setValue(e.target.value);
        // Leaving "Specific date range" drops its dates, so coming back starts empty.
        if (e.target.value !== 6) {
            storeStartDate(null);
            storeEndDate(null);
        }
    };

    const RangeStyle = {
        font: "normal normal normal 15px/21px Roboto",
        color: "#636363",
        margin: "5px",
    };

    const disabledStartDate = (current) => {
        if (!endDateContainer) {
            return current >= moment().endOf("day");
        }
        return current >= moment().endOf("day") || current >= moment(endDateContainer).endOf("day");
    };

    const disabledDate = (current) => {
        if (!startDateContainer) {
            return current >= moment().endOf("day");
        }
        return current >= moment().endOf("day") || current <= moment(startDateContainer).startOf("day");
    };

    useEffect(() => {
        storeStartDate(null);
        storeEndDate(null);
        storeSelectedRange(null);
    }, []);

    // Every open starts fresh — nothing carried over from a previous open
    // that was closed without downloading.
    useEffect(() => {
        if (!drawerVisible) return;
        setValue(0);
        storeStartDate(null);
        storeEndDate(null);
        storeSelectedRange(null);
    }, [drawerVisible]);
    return (
        <Drawer
            // title="Select range"
            placement="right"
            onClose={handleCancel}
            visible={drawerVisible}
            width={450}
            closable={false}
        >
            <div className='drawer-title'>
                <div style={{ fontWeight: 500, fontSize: 17 }}> Select range</div>
                <div><CloseOutlined style={{ fontSize: 16, color: '#AEAEAE' }} onClick={handleCancel} /></div>
            </div>
            <div className='drawer-height'>
                <Radio.Group
                    onChange={onRadioChange}
                    value={value}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        padding: '0px 20px 0px 20px'
                    }}
                >
                    {/* <Radio
                    onClick={() => storeSelectedRange("today")}
                    value={3}
                    style={{ marginTop: "20px" }}
                >
                    <div style={RangeStyle}>Today</div>
                </Radio>
                <Radio
                    onClick={() => storeSelectedRange("yesterday")}
                    value={4}
                    style={{ marginTop: "5px" }}
                >
                    <div style={RangeStyle}>Yesterday</div>
                </Radio> */}
                    <Radio
                        onClick={() => storeSelectedRange("lastweek")}
                        value={1}
                        style={{ marginTop: "15px" }}
                    >
                        <div style={RangeStyle}>Last week</div>
                    </Radio>
                    <Radio
                        onClick={() => storeSelectedRange("lastmonth")}
                        value={2}
                        style={{ marginTop: "15px" }}
                    >
                        <div style={RangeStyle}>Last month</div>
                    </Radio>
                    <Radio
                        style={{ marginTop: "15px" }}
                        onClick={() => { storeSelectedRange("lastthreemonths") }}
                        value={7}>
                        <div style={RangeStyle}>Last 3 months</div></Radio>
                    <Radio
                        style={{ marginTop: "15px" }}
                        onClick={() => { storeSelectedRange("lastsixmonths") }}
                        value={8}>
                        <div style={RangeStyle}>Last 6 months</div></Radio>
                    <Radio
                        style={{ marginTop: "15px" }}
                        onClick={() => { storeSelectedRange("yeartodate") }}
                        value={9}>
                        <div style={RangeStyle}>Year to date</div> </Radio>
                    <Radio
                        onClick={() => {
                            setValue(6);
                            storeSelectedRange("specificDateRange");
                        }}
                        value={6}
                        style={{ marginTop: "15px" }}
                    >
                        <div style={RangeStyle}>Specific date range</div>
                    </Radio>

                </Radio.Group>

                {value === 6 && (
                    <div style={{ display: "flex", gap: 44, padding: "12px 20px 0 49px" }}>
                        <div className='download-date report-range-date' style={{ flex: 1 }}>
                            {/* <div style={{ color: "#636363", fontSize: "13px" }}>
                                Start date
                            </div> */}
                            <DatePicker
                                allowClear
                                format={"DD/MM/YYYY"}
                                placeholder='Start date'
                                value={startDateContainer ? moment(startDateContainer) : null}
                                suffixIcon={<img src={calendarIcon} alt="" style={{ width: 24, height: 24 }} />}
                                style={{ width: "100%", height: 40, border: 'none', borderBottom: '1px solid #E6E6E6', borderRadius: 0 }}
                                onChange={(e) => {
                                    // Cleared start -> clear (and disable) the end date too.
                                    if (!e) { storeStartDate(null); storeEndDate(null); return; }
                                    storeStartDate(e.format("YYYY-MM-DD"));
                                }}
                                disabledDate={disabledStartDate}
                                inputReadOnly={true}
              
                            />
                        </div>
                        <div className='download-date report-range-date' style={{ flex: 1, opacity: startDateContainer ? 1 : 0.5 }}>
                            {/* <div style={{ color: "#636363", fontSize: "13px" }}>End date</div> */}
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                allowClear
                                placeholder='End date'
                                disabled={!startDateContainer}
                                value={endDateContainer ? moment(endDateContainer) : null}
                                suffixIcon={<img src={calendarIcon} alt="" style={{ width: 24, height: 24 }} />}
                                style={{ width: "100%", height: 40, border: 'none', borderBottom: '1px solid #E6E6E6', borderRadius: 0 }}
                                onChange={(e) => storeEndDate(e ? e.format("YYYY-MM-DD") : null)}
                                disabledDate={disabledDate}
                                inputReadOnly={true}
                     

                            />
                        </div>
                    </div>
                )}
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: '0px 20px 0px 20px'
                }}
            >

                <Button type="" style={{
                    backgroundColor: "#FFFFFF", color: "#AEAEAE", borderRadius: 8, border: '2px solid #AEAEAE', display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 500
                }}
                    onClick={handleCancel} >CANCEL</Button>
                <Button

                    disabled={
                        value === 6
                            ? !startDateContainer || !endDateContainer
                            : value === 0
                    }
                    className="m-l-30"
                    style={{
                        borderRadius: 8,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: "#594099",
                        color: '#FFFFFF',
                        opacity: isDownloadBtnLoading
                            ? 0.7
                            : value === 6
                                ? !startDateContainer || !endDateContainer
                                    ? 0.5
                                    : 1
                                : value === 0
                                    ? 0.5
                                    : 1,
                        cursor: isDownloadBtnLoading ? 'default' : undefined,
                        pointerEvents: isDownloadBtnLoading ? 'none' : undefined,
                    }}
                    type="primary"
                    onClick={() => {
                        if (isDownloadBtnLoading) return;
                        setIsDownloadBtnLoading(true);
                        usersDownloadReport(
                            // Report request done — only stop here if it failed.
                            (response) => {
                                if (response === undefined) setIsDownloadBtnLoading(false);
                            },
                            // File downloaded — stop and close the drawer.
                            () => {
                                setIsDownloadBtnLoading(false);
                                setDrawerVisible(false);
                            }
                        );
                    }}
                >
                    {isDownloadBtnLoading ? 'DOWNLOADING...' : 'DOWNLOAD'}
                </Button>
            </div>
        </Drawer>
    );
};

export default ReportDrawer;
